import React, { useContext, useEffect, useRef, useState } from "react";
import "./SelectWithFlags.css";
import enFlag from "../../../public/assets/en-flag.png";
import esFlag from "../../../public/assets/spain-flag.png";
import arrow from "../../../public/assets/icon/Outlined_arrow-right.svg";
import { useTranslation } from "react-i18next";
import { quoteContext } from "../../context/quotesContext";

const SelectWithFlags = () => {
  const {setLanguage} = useContext(quoteContext);
  const [t, i18n] = useTranslation();
  const [isHovered, setIsHovered] = useState(false);
  const [selectedOption, setSelectedOption] = useState(()=>{
    const lenguaje = JSON.parse(localStorage.getItem('lenguaje'))?.label || 'es';

    return {
      flag: lenguaje==='en'? enFlag: esFlag,
      label: lenguaje==='en'? "en": "es",
    }
  });
  const hoverTargetRef = useRef(null);

  const setOptionAndSave = (option) => {
    localStorage.setItem("lenguaje", JSON.stringify(option));
  }

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClick = () => {
    setIsHovered(!isHovered);
  };

  const handleClickOutside = (event) => {
    if (
      hoverTargetRef.current &&
      !hoverTargetRef.current.contains(event.target)
    ) {
      setIsHovered(false);
    }
  };

  const handleOptionClick = (flag, label) => {
    setSelectedOption({ flag, label });
    setIsHovered(false);
    i18n.changeLanguage(label);
    setOptionAndSave({ flag, label });
    setLanguage(label);
  };

  useEffect(()=> {
    i18n.changeLanguage(JSON.parse(localStorage.getItem('lenguaje'))?.label || 'es');

  },[]);
 
  return (
    <div className="select-leng-container" ref={hoverTargetRef}>
      <div className="selected-lang-option" onClick={handleClick}>
        <img src={selectedOption.flag} alt="Selected Flag" className="flag-icon" />
        {selectedOption.label}
        <img
          src={arrow}
          className={`flag-arrow ${isHovered ? "rotate" : ""}`}
        />
      </div>
      {isHovered && (
        <div className="select-with-flags">
          <div
            className={`flag-option ${selectedOption.label === "En" ? "selected" : ""}`}
            onClick={() => handleOptionClick(enFlag, "en")}
          >
            <img src={enFlag} alt="US Flag" className="flag-icon" />{t('english')}
          </div>
          <div
            className={`flag-option ${selectedOption.label === "Es" ? "selected" : ""}`}
            onClick={() => handleOptionClick(esFlag, "es")}
          >
            <img src={esFlag} alt="Spain Flag" className="flag-icon" />{t('spanish')}
          </div>
        </div>
      )}
    </div>
  );
};

export default SelectWithFlags;
